const DistributionChannelsEnum = Object.assign({
  exporo_financing: 'exporo-financing',
  exporo_yield: 'exporo-yield',
  propvest: 'propvest',
  exporo_investmentplan: 'exporo-investmentplan',
  propvest_investmentplan: 'propvest-investmentplan',
  none: 'none',
});

Object.freeze(DistributionChannelsEnum);

export default DistributionChannelsEnum;



// WEBPACK FOOTER //
// ./src/enum/financialProducts/DistributionChannels.js